import { render, staticRenderFns } from "./BienBan.vue?vue&type=template&id=5a9df2ed&scoped=true"
import script from "./BienBan.vue?vue&type=script&lang=js"
export * from "./BienBan.vue?vue&type=script&lang=js"
import style0 from "./BienBan.vue?vue&type=style&index=0&id=5a9df2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9df2ed",
  null
  
)

export default component.exports